module.exports = "<a [routerLink]=\"[params.inRouterLink, params.data.id]\">{{ params.value }}</a>\r\n"